import React from 'react';
export function HookSection() {
  return <section className="py-12 px-4 bg-dark" data-id="element-150">
      <div className="max-w-[680px] mx-auto text-center space-y-[12px] text-base text-body leading-[1.5]" data-id="element-151">
        <p data-id="element-152">
          Te levantas. Ya estás cansado. No es el sueño. No es el trabajo. Es
          algo más profundo que no puedes nombrar.
        </p>

        <p data-id="element-153">
          Por dentro hay un ruido que no para — y{' '}
          <span className="text-white font-medium" data-id="element-154">
            nadie te enseñó a apagarlo.
          </span>
        </p>

        <p className="text-xl md:text-2xl font-serif text-gold mt-6 font-bold leading-[1.4]" data-id="element-155">
          Esto no es debilidad.
          <br data-id="element-156" />
          Es que tu mente necesita un Reset.
        </p>
      </div>
    </section>;
}